<template>
  <div>
    <div class="wrapper" style="background-color: #fff" v-if="goodsData">
      <GoodsSwiper :bookList="goodsData.pics" class="banner" />
      <!-- 图书信息 -->
      <div class="infor-card container">
        <div class="infor">
          <div class="price">
            <!-- 有会员价 -->
            <template v-if="goodsData.product.membership_price">
              <!-- 有会员资格 -->
              <template v-if="goodsData.is_membership_price">
                <p class="price-text price-text_vip" v-if="goodsData.product.membership_price">
                  <span class="symbol">会员价</span>
                  <span class="number">
                    {{ clearPriceZero(goodsData.product.membership_price) }}
                  </span>
                  <span class="symbol">元</span>
                </p>
              </template>
              <!-- 没有会员资格 -->
              <template v-else>
                <p class="price-text price-text_new">
                  <span class="symbol">￥</span>
                  <span class="number">{{ clearPriceZero(goodsData.product.price) }}</span>
                </p>
                <p class="price-text price-text_vip" v-if="goodsData.product.membership_price">
                  <span class="symbol">
                    会员价￥{{ clearPriceZero(goodsData.product.membership_price) }}
                  </span>
                </p>
              </template>
            </template>

            <!-- 非会员价 -->
            <template v-else>
              <p class="price-text price-text_new">
                <span class="symbol">￥</span>
                <span class="number">{{ clearPriceZero(goodsData.product.price) }}</span>
              </p>
              <p
                class="price-text price-text_old"
                style="margin-left: 0.2rem"
                v-if="clearPriceZero(goodsData.product.o_price) !== '0'"
              >
                <span class="number">￥{{ clearPriceZero(goodsData.product.o_price) }}</span>
              </p>
            </template>
          </div>
          <div class="sales">已售{{ goodsData.participants }}</div>
        </div>
        <!-- <GoodsCoupons class="Goods-coupons" :coupons="goodsData.coupon" /> -->
        <GoodsInfoTitle :title="goodsData.name" />
        <div class="describe">{{ goodsData.summary }}</div>
        <div class="explain">
          <img src="@/assets/images/book/icon_tips.png" class="icon" />
          {{ goodsData.prompt_text }}
        </div>
      </div>

      <van-tabs
        v-model="tabsActiveIndex"
        :scrollspy="true"
        sticky
        class="jbc-tabs"
        :class="tabsList.length <= 1 ? 'hideTabNav' : ''"
      >
        <van-tab v-for="(item, index) in tabsList" :title="item.name" :key="index">
          <!-- 介绍页 -->
          <template v-if="item.listKey == 'intro'">
            <div class="goods-catalog">
              <div class="container">
                <div class="container-row" v-if="item.listKey == 'intro'">
                  <div v-html="bodyInfo(item.list)" class="imgBox"></div>
                </div>
              </div>
            </div>
          </template>
          <!-- 推荐 -->
          <template v-else>
            <div class="goods-catalog">
              <div class="container">
                <div class="header">
                  <span class="title">{{ item.name }}</span>
                  <span class="subtitle">{{ item.list.length }}个</span>
                </div>
                <ul class="catalog-list">
                  <li v-for="(item, index) in item.list" :key="index">
                    <div class="catalog-card" @click="clickRecommendCard(item)">
                      <div class="header">
                        <img class="img" :src="item.img" />
                      </div>
                      <div class="content">
                        <p class="name">{{ item.name }}</p>
                        <p class="text">
                          <span>{{ item.summary }}</span>
                        </p>
                        <div class="detail">
                          <p class="sale">已售 {{ item.participants }}</p>
                          <div class="price">
                            <p class="price-news">
                              <span>￥</span>
                              <span class="font">{{ clearPriceZero(item.product.price) }}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </template>
        </van-tab>
      </van-tabs>

      <FooterButtonBuy
        buttonText="立即购买"
        :isDisable="isDisableButton"
        :customerInfoURL="customerURL"
        @clickButton="buy"
      />

      <SideOpenApp unitKey="StoreDetail" :options="{ no: goodsData.no }" />
    </div>
    <!-- 打开app方法调用 -->
    <FooterOpenApp
      ref="footer_open_app"
      :name="getCurrentBrand.name"
      schemaUnitKey="StoreDetail"
      style="display: none"
    />
  </div>
</template>
<script>
import { getBookDetailApi } from '@/api/book/detail'
import FooterButtonBuy from '@/components/FooterButtonBuy.vue'
import GoodsCoupons from '@/components/Goods/GoodsCoupons.vue'
import GoodsSwiper from '@/components/Goods/GoodsSwiper.vue'
import GoodsInfoTitle from '@/components/GoodsInfo/GoodsInfoTitle.vue'
import SideOpenApp from '@/components/SideOpenApp.vue'
import { clearPriceZero } from '@/utils/util'
import mixinGoodsCommon from '@/views/goods/mixins/goodsCommon'
import { removePayOrderNo, removeShoppingInfor } from '@/utils/cookies'
import OpenApp from '@/components/OpenApp.vue'
import footerOpenApp from '@/components/FooterOpenApp'
export default {
  components: {
    GoodsSwiper,
    GoodsInfoTitle,
    GoodsCoupons,
    FooterButtonBuy,
    SideOpenApp,
    OpenApp,
    footerOpenApp,
  },
  mixins: [mixinGoodsCommon],
  data() {
    return {
      tabsActiveIndex: 0,
      tabsList: [],
      goodsData: null, //图书详情数据

      bookNo: '', //图书no
      bookType: '', //图书类型
      productNo: '', //商品规格no

      isDisableButton: false, //是否禁用够买按钮
    }
  },
  computed: {
    // 客服url
    customerURL() {
      // 先取出客服列表 & 客户信息（避免重复?.）
      const serviceList = this.goodsData?.customer_service || []
      const customerInfo = this.goodsData?.customer_info

      // 优先取客服第一条，没有则取客户信息里的url
      return serviceList.length > 0 ? serviceList[0].value : customerInfo?.url
    },
  },
  metaInfo() {
    return {
      meta: [
        // { property: 'tiku:share', content: true },
        // { property: 'tiku:share_title', content: this.goodsData.share?.title },
        // {
        //     property: 'tiku:share_description',
        //     content: this.goodsData.share?.desc,
        // },
        // { property: 'tiku:share_image', content: this.goodsData.share?.image },
        // { property: 'tiku:share_url', content: window.location.href },
      ],
    }
  },
  methods: {
    // 获取图书详情
    getBookDetail() {
      let query = this.routeFixedParam()
      query.type = this.bookType
      query.no = this.bookNo
      getBookDetailApi(query).then((res) => {
        this.goodsData = res.data
        this.initTabsList(this.goodsData)
        /**
         * Initializes the tab list for goods display
         * @param {Object} goods - The goods data containing product information
         * @returns {Array} An array of tab objects with name and listKey properties
         */
        this.setShareCard(this.goodsData)
      })
    },
    // 初始化tab列表
    initTabsList(goods) {
      const result = []
      if (goods.intro) {
        result.push({
          name: '介绍',
          listKey: 'intro',
          list: goods.intro,
        })
      }
      if (goods.recommend.length > 0) {
        result.push({
          name: '推荐',
          listKey: 'recommend',
          list: goods.recommend,
        })
      }
      this.tabsList = result
    },
    // 点击推荐卡片
    clickRecommendCard(cardInfo) {
      let query = this.routeFixedParam()
      query.type = cardInfo.type
      query.no = cardInfo.no
      const newPath = this.$router.resolve({
        path: '/book/detail',
        query,
      })
      this.$util.windowLocationHref(newPath.href)
    },
    buy() {
      if (this.isAPP()) {
        return false
      }
      if (this.checkUserNotLogin()) {
        return false
      }
      let o = {}
      o.product_no = this.goodsData.product.no
      o.case_id = this.goodsData.product.id
      o.count = 1
      this.goPay([o])
    },
    // 设置分享卡片
    setShareCard(goodsData) {
      const shareOpiton = goodsData.share || {}
      setTimeout(() => {
        this.$util.setShare({
          title: shareOpiton.title,
          desc: shareOpiton.desc,
          link: window.location.href,
          imgUrl: shareOpiton.image || '',
        })
      })
    },
    // 打开app
    openApps() {
      setTimeout(() => {
        this.$refs.footer_open_app.openApp()
      })
    },
    //判断是否是app
    checkIsAPP() {
      if (window?.tikuWeb?.setShareHtml) {
        this.openApps()
        setTimeout(() => {
          window.history.back()
        }, 1500)
        return true
      }
      if (window?.webkit?.messageHandlers?.canLoadShare) {
        this.openApps()
        setTimeout(() => {
          window.close()
        }, 1500)
        return true
      }
      return false
    },
    setupRecommendCode() {
      const query = this.$route.query
      // 获取目标路由的完整 URL 或查询参数
      const rcode = query.rcode || ''

      if (rcode) {
        const rcode_range = 'physicalgoods'
        const rcode_value = query.no

        this.$store.dispatch('recommendCode/setRecommendCode', {
          rcode: rcode,
          rcode_range,
          rcode_value,
        })
      }
    },
  },
  mounted() {
    this.bookType = this.$route.query.type
    this.bookNo = this.$route.query.no
    this.getBookDetail()
    removePayOrderNo()
    removeShoppingInfor()
  },
  created() {
    this.checkIsAPP() //app内自动跳转页面
    this.setupRecommendCode(this.$route.query, {
      rcode_range: 'physicalgoods',
    })
  },
}
</script>
<style lang="scss" scoped>
.wrapper {
  padding-bottom: 1.6rem;
  width: 100%;
  overflow: hidden;
}

.banner {
  margin-bottom: 0.32rem;
}

.goods-catalog {
  padding-top: 0.2rem;
  padding-bottom: 0.5rem;

  .header {
    .title {
      font-size: 0.43rem;
      font-weight: bold;
    }

    .subtitle {
      font-size: 0.35rem;
      color: #919499;
      margin-left: 0.2rem;
    }
  }
}

.goods-coupons {
  margin-bottom: 0.4rem;
}

.infor-card {
  border-bottom: 0.2rem solid #f7f8fa;

  .infor {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 0.27rem;

    .sales {
      font-size: 0.32rem;
      line-height: 0.61rem;
      color: #919499;
      opacity: 0.86;
    }
  }

  .describe {
    font-size: 0.32rem;
    font-weight: 400;
    line-height: 0.48rem;
    color: #919499;
    opacity: 0.86;
    margin-bottom: 0.43rem;
  }

  .explain {
    position: relative;
    padding: 0.2rem;
    background: rgba(252, 246, 240, 0.5);
    border-radius: 0.11rem;
    font-size: 0.29rem;
    line-height: 0.4rem;
    color: #e5b66e;
    margin-bottom: 0.53rem;
    padding-left: 1rem;

    .icon {
      @include position_centerY;
      position: absolute;
      left: 0.32rem;
      width: 0.43rem;
    }
  }
}

.catalog-list {
  > li {
    padding: 0.64rem 0;

    & + li {
      border-top: 0.01rem solid #ebecf0;
    }

    .header {
      @include position_centerY;
      @include flex_center;
      width: 2.6rem;
      height: 100%;

      .img {
        width: 2.35rem;
      }
    }

    .content {
      margin-left: 2.9rem;
      height: 2.45rem;
      position: relative;

      .name {
        @include ellipsis(2);
        white-space: inherit;
        font-size: 0.37rem;
        line-height: 0.53rem;
        color: #22242e;
      }

      .text {
        @include ellipsis(1);
        margin-top: 0.1rem;
        font-size: 0.29rem;
        color: #919499;
        opacity: 0.8;
      }

      .detail {
        display: flex;
        justify-content: space-between;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 0.5rem;
        color: #919499;

        .price {
          display: flex;
          align-items: flex-end;
          line-height: $font40;

          &-old {
            text-decoration: line-through;
          }

          &-news {
            color: #ff6a4d;
            font-size: 0.32rem;
            margin-left: 0.1rem;
            font-weight: bold;
            font-family: DIN;

            .font {
              font-size: 0.43rem;
            }
          }
        }
      }
    }

    .sale {
      font-size: 0.29rem;
      line-height: 0.51rem;
      color: #919499;
    }
  }

  .catalog-card {
    position: relative;
  }
}

.price {
  display: flex;
  align-items: flex-end;

  &-text {
    font-family: DIN;

    .symbol {
      font-size: 0.37rem;
    }

    .number {
      font-size: 0.56rem;
      font-weight: bold;
    }

    &_new {
      color: #ff6a4d;
    }

    &_old {
      color: #c2c5cc;
      text-decoration: line-through;
      font-size: 0.27rem;
      line-height: 0.51rem;

      .number {
        font-size: 0.27rem;
        font-weight: normal;
      }
    }

    &_vip {
      font-size: 0.29rem;
      color: #e5b66e;
      margin-left: 0.2rem;

      .number {
        font-size: 0.56rem;
      }
    }
  }
}

.goods {
  &-specs {
    &-item {
      display: flex;
      padding: 0.1rem 0;

      .name {
        width: 1.92rem;
        font-size: 0.32rem;
        color: #919499;
        line-height: 0.4rem;
      }

      .content {
        position: relative;
        display: flex;
        align-items: flex-end;
        flex: 1;
        font-size: 0;

        .text {
          font-size: 0.32rem;
          line-height: 0.4rem;
          color: #3c3d42;
        }
      }
    }
  }
}
</style>
